import React, { Component } from 'react'
import styled from 'styled-components'

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  max-width: 35rem;
  position: absolute;
  left: 50%;
  padding: 0 0 2rem 0;
  transform: translate(-50%, 0);
`

const Logo = styled.img`
  width: 45%;
  margin: 3rem 0 1.5rem 0;
`

export default class AuthLayout extends Component {
  render() {
    const { children } = this.props

    return (
      <Page>
        <Logo alt="" src="/images/logo-long.png" />
        {children}
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/AuthLayout.js